<template>
    <v-autocomplete
        ref="autocomplete"
        label="Usuários"
        :items="itensAutocomplete"
        item-text="nome"
        return-object
        v-model="usuariosSelecionados"
        multiple
        chips
        deletable-chips
        :search-input.sync="busca"
        :loading="carregando"
    >
        <template v-slot:no-data>
            <v-list-item>
                <v-list-item-title>
                    {{ mensagemSemDados }}
                </v-list-item-title>
            </v-list-item>
        </template>
        <template v-slot:selection="{ item }">
            <v-chip
                small
                close
                @click:close="
                    usuariosSelecionados = usuariosSelecionados.filter(
                        (u) => u !== item,
                    )
                "
            >
                {{ item.cpf }} - {{ item.nome }}
            </v-chip>
        </template>
        <template v-slot:item="{ item }">
            <v-list-item-content>
                <v-list-item-title>
                    {{ item.nome }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ item.matricula }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import debounce from "lodash/debounce";
import { getServicoGuardiao } from "../../../services/ServicosFactory";

const servicoGuardiao = getServicoGuardiao();

export default {
    name: "MultiSelectGuardiao",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            usuarios: [],
            busca: "",
            carregando: false,
        };
    },
    computed: {
        usuariosSelecionados: {
            get() {
                return this.value;
            },
            set(novoValor) {
                this.$emit("input", novoValor);
            },
        },
        itensAutocomplete() {
            const buscadosNaoSelecionados = this.usuarios.filter(
                (u) =>
                    !this.usuariosSelecionados.some(
                        (selecionado) => selecionado.matricula === u.matricula,
                    ),
            );
            return [...this.usuariosSelecionados, ...buscadosNaoSelecionados];
        },
        mensagemSemDados() {
            if (this.carregando) {
                return "Buscando...";
            }
            if (!this.busca || this.busca.length < 3) {
                return "Digite ao menos 3 caracteres";
            }
            return "Nenhum usuário encontrado";
        },
    },
    methods: {
        async buscarUsuarios(valor) {
            if (!valor || valor.length < 3) {
                this.usuarios = [];
                return;
            }

            this.carregando = true;
            try {
                this.usuarios = await servicoGuardiao.buscarUsuarios(valor);
            } catch (erros) {
                console.error("Erro ao buscar usuários:", erros);
                this.usuarios = [];
            } finally {
                this.carregando = false;
            }
        },
        async completarCpfUsuarioSelecionado(item) {
            try {
                const pessoa = await servicoGuardiao.buscarPessoaPorMatricula(
                    item.matricula,
                );
                const cpf = pessoa.cpf;
                const cpfJaSelecionado = this.usuariosSelecionados.some(
                    (u) => u.matricula !== item.matricula && u.cpf === cpf,
                );
                if (cpfJaSelecionado) {
                    this.usuariosSelecionados =
                        this.usuariosSelecionados.filter(
                            (u) => u.matricula !== item.matricula,
                        );
                    return;
                }
                this.usuariosSelecionados = this.usuariosSelecionados.map((u) =>
                    u.matricula === item.matricula
                        ? {
                              matricula: item.matricula,
                              nome: pessoa.nome.trim(),
                              cpf,
                          }
                        : u,
                );
            } catch (erro) {
                console.error("Erro ao buscar CPF do usuário:", erro);
                this.usuariosSelecionados = this.usuariosSelecionados.filter(
                    (u) => u.matricula !== item.matricula,
                );
            }
        },
    },
    watch: {
        busca: {
            handler: debounce(function (novoValor) {
                this.buscarUsuarios(novoValor);
            }, 300),
        },
        usuariosSelecionados(novoValor, valorAntigo) {
            if (novoValor.length > valorAntigo.length) {
                this.busca = "";
                this.$nextTick(() => {
                    this.$refs.autocomplete.isMenuActive = false;
                });
            }
            const adicionados = novoValor.filter(
                (item) =>
                    !item.cpf &&
                    !valorAntigo.some(
                        (antigo) => antigo.matricula === item.matricula,
                    ),
            );
            adicionados.forEach((item) =>
                this.completarCpfUsuarioSelecionado(item),
            );
        },
    },
};
</script>
